// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img{max-width:100%}@media(max-width:500px){.q-btn--rounded .block{padding-left:50px;padding-right:50px}}@media(max-width:400px){.btn-mts{padding:12px 20px}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
